{
  "upgradeGuideFiles": [
    "upgrade-guides/9.0-UPGRADE-GUIDE.md",
    "upgrade-guides/10.0-UPGRADE-GUIDE.md",
    "upgrade-guides/11.0-UPGRADE-GUIDE.md",
    "upgrade-guides/12.0-UPGRADE-GUIDE.md",
    "upgrade-guides/13.0-UPGRADE-GUIDE.md",
    "upgrade-guides/14.0-UPGRADE-GUIDE.md",
    "upgrade-guides/15.0-UPGRADE-GUIDE.md",
    "upgrade-guides/16.0-UPGRADE-GUIDE.md",
    "llm-style-props-migration.txt",
    "theming.md"
  ],
  "iconMigrationFiles": ["icons/icon-migration.md", "icons/icon-migration-codemod.md"],
  "tokenFiles": [
    "tokens/token-migration.md",
    "tokens/color-palette.md",
    "tokens/color-tokens.md",
    "tokens/color-contrast.md",
    "tokens/color-roles.md",
    "tokens/color-scale.md",
    "llm-token-migration-14.txt",
    "tokens/v4/v4-token-migration.md",
    "tokens/v4/v4.4-token-reference.md",
    "tokens/v4/color.md",
    "tokens/v4/opacity.md",
    "tokens/v4/shape.md",
    "tokens/v4/size.md",
    "tokens/v4/space.md"
  ],
  "accessibilityFiles": [
    {
      "source": "accessibility/AccessibilityOverview.mdx",
      "slug": "overview"
    },
    {
      "source": "accessibility/PageStructure.mdx",
      "slug": "page-structure"
    },
    {
      "source": "accessibility/TablesAdvanced.mdx",
      "slug": "tables"
    },
    {
      "source": "accessibility/Popups.mdx",
      "slug": "popups"
    },
    {
      "source": "accessibility/AriaLiveRegions.mdx",
      "slug": "aria-live"
    },
    {
      "source": "accessibility/Headers.mdx",
      "slug": "headers"
    },
    {
      "source": "accessibility/SidePanel.mdx",
      "slug": "side-panel"
    },
    {
      "source": "accessibility/WindowsHighContrastThemes.mdx",
      "slug": "windows-high-contrast"
    },
    {
      "source": "accessibility/TestingTableWithFormFields.mdx",
      "slug": "forms"
    },
    {
      "source": "accessibility/WindowsHighContrastThemes.mdx",
      "slug": "color-contrast"
    }
  ]
}
